/*
 * The distribution editor: the clamp warning, the ceiling, and the two tables of rows.
 */
.warning {
  margin: 0;
  padding: var(--space-3);
  border: 1px solid var(--warning-text);
  border-radius: var(--radius-control);
  background-color: var(--warning-surface);
  color: var(--warning-text);
  font-size: var(--font-size-13);
}

.problem {
  margin: var(--space-1) 0 0;
  color: var(--danger-text);
  font-size: var(--font-size-12);
}

.clamped {
  display: block;
  color: var(--warning-text);
}

.secondary {
  display: block;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-regular);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.visuallyHidden {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}
